/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Peer_Support_DescriptionInputs */

const en_service_peer_support_description = /** @type {(inputs: Service_Peer_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Give your mental well-being a boost with the anonymous online peer-to-peer support group.`)
};

const fr_service_peer_support_description = /** @type {(inputs: Service_Peer_Support_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Améliorez votre bien-être mental grâce au groupe de soutien anonyme en ligne entre pairs.`)
};

/**
* | output |
* | --- |
* | "Give your mental well-being a boost with the anonymous online peer-to-peer support group." |
*
* @param {Service_Peer_Support_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const service_peer_support_description = /** @type {((inputs?: Service_Peer_Support_DescriptionInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Peer_Support_DescriptionInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_service_peer_support_description(inputs)
	return fr_service_peer_support_description(inputs)
});